module.exports = __webpack_public_path__ + "static/media/icoHidePassword.9e785882.svg";